<div class="d-flex flex-wrap gap-3 justify-content-between mb-3">
  <!-- view options -->
  <div>
    <div class="nav nav-segment me-3">
      <a
        href="javascript:;"
        class="nav-link"
        [ngClass]="{
          active: (getActiveView$() | async) == serieProposalViews.CALENDAR
        }"
        (click)="onClickSelectedView(serieProposalViews.CALENDAR)"
      >
        <i role="img" class="fa fa-clock" aria-hidden="true"></i>
        {{ 'bookingModule.schedule' | translate }}
      </a>

      <a
        href="javascript:;"
        class="nav-link"
        [ngClass]="{
          active: (getActiveView$() | async) == serieProposalViews.LIST
        }"
        (click)="onClickSelectedView(serieProposalViews.LIST)"
      >
        <i role="img" class="fa fa-list-alt" aria-hidden="true"></i>
        {{ 'general.list' | translate }}
      </a>
    </div>
    <!-- status filters -->
    <div class="nav nav-segment">
      <a
        class="nav-link"
        [ngClass]="{
          active: (getActiveTab$() | async) === serieProposalTabs.DEFAULT
        }"
        (click)="onClickSelectedTab(serieProposalTabs.DEFAULT)"
      >
        <i role="img" class="fa fa-cube" aria-hidden="true"></i>
        {{ 'general.default' | translate }}
      </a>
      <a
        class="nav-link"
        [ngClass]="{
          active:
            (getActiveTab$() | async) === serieProposalTabs.COUNTER_PROPOSAL
        }"
        (click)="onClickSelectedTab(serieProposalTabs.COUNTER_PROPOSAL)"
      >
        <i role="img" class="fa fa-sync-alt" aria-hidden="true"></i>
        {{ 'serieProposalModule.counterProposal' | translate }}
      </a>
      <a
        href="javascript:;"
        class="nav-link"
        [ngClass]="{
          active: (getActiveTab$() | async) === serieProposalTabs.REQUESTED
        }"
        (click)="onClickSelectedTab(serieProposalTabs.REQUESTED)"
      >
        <i role="img" class="fa fa-folder-open" aria-hidden="true"></i>
        {{ 'serieProposalModule.requested' | translate }}
      </a>
      <a
        href="javascript:;"
        class="nav-link"
        [ngClass]="{
          active: (getActiveTab$() | async) === serieProposalTabs.ACCEPTED
        }"
        (click)="onClickSelectedTab(serieProposalTabs.ACCEPTED)"
      >
        <i role="img" class="fa fa-check" aria-hidden="true"></i>
        {{ 'serieProposalModule.accepted' | translate }}
      </a>

      <a
        href="javascript:;"
        class="nav-link"
        [ngClass]="{
          active: (getActiveTab$() | async) === serieProposalTabs.DECLINED
        }"
        (click)="onClickSelectedTab(serieProposalTabs.DECLINED)"
      >
        <i role="img" class="fa fa-times-circle" aria-hidden="true"></i>
        {{ 'serieProposalModule.declined' | translate }}
      </a>
      <a
        href="javascript:;"
        class="nav-link"
        [ngClass]="{
          active: (getActiveTab$() | async) === serieProposalTabs.ALL
        }"
        (click)="onClickSelectedTab(serieProposalTabs.ALL)"
      >
        <i role="img" class="fa fa-cube" aria-hidden="true"></i>
        {{ 'general.all' | translate }}
      </a>
    </div>
  </div>

  <ng-container
    *ngIf="(getActiveView$() | async) == serieProposalViews.CALENDAR"
  >
    <form [formGroup]="form" class="flex-grow-1 d-flex justify-content-end">
      <label class="col-form-label me-3">
        {{ 'serieProposalModule.dateRange' | translate }}
      </label>
      <nz-range-picker
        [nzShowTime]="false"
        [nzSize]="'large'"
        formControlName="dateRange"
      ></nz-range-picker>
    </form>
  </ng-container>
</div>

<form [formGroup]="form" [patchForm]="selectedFilters$ | async">
  <h4>
    {{ 'general.selectAFilter' | translate }}
  </h4>
  <div
    *ngIf="
      !form.get('selectedBookableProductIds')?.value?.length &&
      !form.get('selectedProductGroupIds')?.value?.length &&
      (getActiveView$() | async) == serieProposalViews.CALENDAR
    "
    class="alert alert-info"
  >
    {{ 'serieProposalModule.selectFirstResourceInfo' | translate }}
  </div>
  <div class="row g-2 mb-4">
    <div class="col-12 col-md-6 col-lg">
      <label class="form-label">
        {{ 'bookingModule.selectResource' | translate }}
      </label>
      <product-select-input-multiple
        [products]="bookableProducts$ | async"
        formControlName="selectedBookableProductIds"
        [allowClearing]="true"
        (search)="onSearchProducts($event)"
        [dataTestId]="'serie-proposal-bookable-multiple-select'"
      >
      </product-select-input-multiple>
    </div>

    <div class="col-12 col-md-6 col-lg">
      <label class="form-label">
        {{ 'bookingModule.selectResourceGroup' | translate }}
      </label>
      <product-select-input-multiple
        (search)="onSearchProductGroups($event)"
        [products]="productGroups$ | async"
        formControlName="selectedProductGroupIds"
        [allowClearing]="true"
        [dataTestId]="'serie-proposal-resource-group-multiple-select'"
      ></product-select-input-multiple>
    </div>

    <div class="col-12 col-md-6 col-lg">
      <label class="form-label">
        {{ 'serieProposalModule.selectOrganization' | translate }}
      </label>
      <product-select-input-multiple
        [products]="organizations$ | async"
        formControlName="selectedOrganizationIds"
        [allowClearing]="true"
        (search)="onSearchOrganizations($event)"
        [dataTestId]="'serie-proposal-organization-multiple-select'"
      >
      </product-select-input-multiple>
    </div>

    <div class="col-12 col-md-6 col-lg">
      <label class="form-label">
        {{ 'serieProposalModule.organizationCategory' | translate }}
      </label>
      <category-select-input-multiple
        formControlName="selectedCategories"
        [allowClearing]="true"
        [dataTestId]="'serie-proposal-category-multiple-select'"
      >
      </category-select-input-multiple>
    </div>
  </div>
</form>

<div
  *ngIf="isLoading$ | async"
  class="spinner-border"
  role="status"
  attr.aria-label="{{ 'general.loading' | translate }}"
>
</div>

<!-- schedule view -->
<serie-proposal-overview-schedule
  *ngIf="(getActiveView$() | async) == serieProposalViews.CALENDAR"
  [selectedBookableProductIds$]="
    selectedBookableProductIdsSubject.asObservable()
  "
  [dependantProductIds$]="dependantProductIds$"
  [serieProposals]="serieProposals"
  [dependantProductsMap]="dependantProductsMap"
  (onFetchSerieProposals)="fetchSerieProposals(true)"
></serie-proposal-overview-schedule>

<!-- list view -->
<serie-proposal-table
  *ngIf="(getActiveView$() | async) == serieProposalViews.LIST"
  [tableData]="setSerieProposalType(serieProposals)"
  [showTotal]="true"
  [activePage]="page"
  [pageCount]="pageCount"
  [limitPage]="limit"
  [total]="total"
  (onSearchTerm)="onSearchTerm($event)"
  (onClickRow)="onClickRow($event)"
  (onSelectedPage)="selectNewPage($event)"
  (onSelectLimit)="selectNewLimit($event)"
  (onSorted)="onSorted($event)"
></serie-proposal-table>
